import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Text } from '@chakra-ui/react';
import { getChildrenProps } from '@varos/util-react';
import { createTrendChartContainer } from './trendContainer';
import { createTrendView } from './trendView';
import { assert } from '@varos/util-typescript';
export function createTrend(config, controller) {
    const DefaultTootip = (props) => {
        return (_jsx(Box, { children: _jsx(Text, { children: props.label }) }));
    };
    const Chart = createTrendChartContainer(controller, createTrendView());
    const components = {
        ChartRoot(props) {
            const childrenProps = getChildrenProps(props.children, {
                Grid: components.ChartGrid,
                Label: components.ChartLabel,
                Tooltip: components.ChartTooltip,
                LegendList: components.ChartLegendList,
                ScalarAxis: components.ChartScalarAxis,
                TimeAxis: components.ChartTimeAxis,
            });
            assert(childrenProps.TimeAxis, 'no time axis configured');
            const legendChildren = getChildrenProps(childrenProps.LegendList?.children, {
                LegendItem: components.ChartLegendItem,
                LegendTooltip: components.ChartLegendTooltip,
            });
            const scalarAxisChildren = getChildrenProps(childrenProps.ScalarAxis?.children, {
                Label: components.ChartLabel,
                Tick: components.ChartTick,
            });
            const theme = {
                legend: {
                    list: childrenProps.LegendList ?? {},
                    item: legendChildren.LegendItem ?? {},
                    tooltip: legendChildren.LegendTooltip ?? null,
                },
                tooltip: {
                    gutter: childrenProps.Tooltip?.p,
                },
                grid: {
                    borderColor: childrenProps.Grid?.borderColor ?? 'inherit',
                },
                label: {
                    color: childrenProps.Label?.color ?? 'inherit',
                    fontWeight: childrenProps.Label?.fontWeight ?? 'inherit',
                    p: childrenProps.Label?.p ?? 'inherit',
                },
                axis: {
                    label: {
                        visible: !!scalarAxisChildren.Label,
                        color: scalarAxisChildren.Label?.color ?? 'inherit',
                        p: scalarAxisChildren.Label?.p ?? 'inherit',
                        fontWeight: scalarAxisChildren.Label?.fontWeight ?? 'inherit',
                    },
                    tick: {
                        p: scalarAxisChildren.Tick?.p ?? 0,
                        color: scalarAxisChildren.Tick?.color ?? 'inherit',
                    },
                    // label: {
                    //     color: scalarAxisChildren.Label?.color ?? 'inherit',
                    //     p: scalarAxisChildren.Label?.p ?? 'inherit',
                    // },
                },
            };
            const axis = {
                scalar: childrenProps.ScalarAxis ?? {
                    unit: null,
                },
                time: childrenProps.TimeAxis,
            };
            const Tooltip = childrenProps.Tooltip?.as ?? DefaultTootip;
            return (_jsx(Chart, { theme: theme, axis: axis, Tooltip: Tooltip, datasets: props.datasets, labels: props.labels, type: props.type, series: props.series }));
        },
        ChartLegendList() {
            return _jsx(_Fragment, {});
        },
        ChartLegendItem() {
            return _jsx(_Fragment, {});
        },
        ChartLegendTooltip() {
            return _jsx(_Fragment, {});
        },
        ChartGrid() {
            return _jsx(_Fragment, {});
        },
        ChartLabel() {
            return _jsx(_Fragment, {});
        },
        ChartTick() {
            return _jsx(_Fragment, {});
        },
        ChartTooltip() {
            return _jsx(_Fragment, {});
        },
        ChartScalarAxis() {
            return _jsx(_Fragment, {});
        },
        ChartTimeAxis() {
            return _jsx(_Fragment, {});
        },
    };
    return {
        controller,
        Component: components,
    };
}
//# sourceMappingURL=trendProvider.js.map